var LLUInvitationStatus;
(function (LLUInvitationStatus) {
    LLUInvitationStatus[LLUInvitationStatus["PENDING"] = 0] = "PENDING";
    LLUInvitationStatus[LLUInvitationStatus["HCP_REJECTED"] = 5] = "HCP_REJECTED";
    LLUInvitationStatus[LLUInvitationStatus["INVALID_REGION"] = 2] = "INVALID_REGION";
    LLUInvitationStatus[LLUInvitationStatus["ALREADY_SENT"] = 1] = "ALREADY_SENT";
})(LLUInvitationStatus || (LLUInvitationStatus = {}));
export default LLUInvitationStatus;
